// Generated i18n file
export default {
  title: '东京Metro 24小时乘车券',
  notes: {
    item1:
      '同时购买多张乘车券时,可在使用开始前通过社交软件等方式分配至各自的智能手机。',
    item2: '如需在1台设备上使用多张二维码时,请务必让持有凭证的客人最后通过。',
    description2:
      '※通过检票机所需时间将比平时更长,可能无法搭乘您期望的列车,敬请预留充裕时间使用。',
    item3: '本乘车券不适用于搭乘东京Metro线以外的路线。',
    item4: '打印出的二维码或截图无法使用。',
    description4:
      '※若因智能手机等设备遗失或电量耗尽等原因导致无法通过画面确认本乘车券的有效性时,将视同未持有乘车券,需支付包含本乘车券有效区间在内的实际乘车区间的规定运费。车站恕不提供充电等服务,敬请提前知晓。',
    item5:
      '超过乘车券有效期间及有效期限后将无法使用。(即使按下使用开始按钮,如当日末班车前未在自动检票机等使用,亦无法使用。)',
    item6:
      '仅限在有效期间内且使用开始前,可在购买历史记录页面办理退款,每笔交易(每次支付)将产生220日元的退款手续费。',
    item7: '出示有效乘车券画面即可享受换乘运输服务。',
    item8:
      '关于二维码乘车券无法使用等疑问,请在邮件中注明"预约号码"和"姓名",联系购买方。',
    description8: '二维码是DENSO WAVE INC.的注册商标。',
    title: '注意事项'
  },
  explain: {
    description1:
      '该乘车券仅限东京Metro线内使用,自使用开始起24小时内可自由乘坐全9条路线,非常划算。',
    description2:
      '在东京Metro线起步价180日元区间(1~6km)内乘坐,只需乘坐4次以上就很划算!',
    title: '使用说明',
    area: '使用区间',
    areaValue: '东京Metro全线',
    howToUse: '使用方法',
    step1: {
      alt: '购买二维码数字车票',
      description:
        '① 二维码乘车券是通过智能手机提前购买二维码数字车票,在自动检票机上扫描二维码即可使用的服务。'
    },
    step2: {
      alt: '在支持二维码的检票口进出',
      description: '② 可在支持二维码的检票口进出。',
      tip: '※在不支持二维码的检票口,请向检票口的站务员咨询。如站务员不在,请通过检票口的对讲机呼叫站务员。'
    },
    step3: {
      alt: '按下使用开始按钮',
      description:
        '③ 使用前请务必按下"使用开始"按钮进行入场处理。"使用开始"按钮按下时刻起开始计算使用期间,因此将无法退款。请务必在使用前按下。'
    },
    validityDescription:
      '购买后90日内的1日,从按下使用开始按钮当日首次通过检票机起24小时内有效',
    validityNotice: '※按下使用开始按钮当日如未使用,将变为无效。',
    validityTitle: '有效期间或有效期限'
  },
  faq: {
    title: '常见问题',
    faqList: [
      {
        answer: `通过一部智能手机即可无现金购买和使用的划算车票。
您手机上显示的二维码和动画可以代替车票使用。
销售以下票种。
・Tokyo Subway 24/48/72-Hour Ticket(QR)
・东京Metro都营地铁共通1日乘车券(QR)
・东京Metro 24小时券(QR)
`,
        question: '什么是二维码企划乘车券?'
      },
      {
        answer: `请在专用网站使用"Google"或"Email"账号登录后,选择数字车票种类,用信用卡支付。
※请用半角罗马字输入注册姓名。`,
        question: '如何购买?'
      },
      {
        answer: 'VISA、MasterCard、JCB、American Express、Diners',
        question: '信用卡支付可使用哪些信用卡?'
      },
      {
        answer: `信用卡公司需要3D Secure认证。
包括设定在内,如无法使用信用卡支付,请向信用卡公司咨询。`,
        question: '无法使用信用卡支付时怎么办?'
      },
      {
        answer: `二维码企划乘车券必须持有智能手机等信息终端才能使用。另外,无法使用屏幕截图。`,
        question: '没有智能手机能否使用二维码企划乘车券?'
      },
      {
        answer: `【年龄区分】
・成人(12岁以上)
  成人运费。但是,13岁以下的小学生适用儿童运费。
・儿童(6岁以上12岁未满)
  儿童运费。但是,6岁尚未入小学的按幼儿计算。
`,
        question: '乘车券的年龄区分是?'
      },
      {
        answer: `代表者为多人一起购买并使用二维码企划乘车券时,如同时购买多张,请在使用开始前通过社交软件等分配至各自的智能手机。如不分配而用1台设备使用多张乘车券,通过检票机所需时间将比平时更长,可能无法搭乘您期望的列车,敬请预留充裕时间使用。
用1台设备使用多张二维码企划乘车券通过自动检票机时,请务必让持有凭证的客人最后通过。
`,
        question: '什么是乘车券分配功能?'
      },
      {
        answer:
          '二维码企划乘车券使用日(乘车日)按下"使用开始"按钮后,如当日末班车前未使用自动检票机,乘车券将变为无效。请务必在乘车日首班车时间之后按下"使用开始按钮"。通过自动检票机时刻起开始计算数字车票的有效期限。',
        question: '乘车券画面上的"使用开始"是什么意思?'
      },
      {
        answer:
          '部分车站的检票口没有支持二维码企划乘车券的自动检票机。请向检票口的站务员咨询。乘车或下车时需要在站务设备上进行处理。另外,对于站务员不在的检票口,请通过对讲机等呼叫站务员。如距离站务室较远,可能需要等待站务员到达,敬请预留充裕时间使用。',
        question: '如果没有支持二维码企划乘车券的检票机怎么办?'
      },
      {
        answer: `仅限在有效期间内且使用开始前的乘车券,可在销售网站上办理退款。(每次支付收取220日元退款手续费)
购买多张二维码企划乘车券办理退款时,无法退款部分乘车券,将全部乘车券一起退款,敬请注意。`,
        question: '能否办理退款?'
      },
      {
        answer: `如因智能手机等信息终端遗失或电池耗尽等导致站务员无法确认二维码企划乘车券画面信息,将视为您未持有有效乘车券,需以现金或IC卡支付实际乘车区间的规定运费。请注意终端的充电状况。车站恕不提供充电等服务,敬请提前知晓。`,
        question: '使用中智能手机故障或电源耗尽时该怎么办?'
      },
      {
        answer: '如能出示有效乘车券,即为换乘运输对象。',
        question: '是否为换乘运输对象?'
      },
      {
        answer: `请联系邮件咨询联系方式。
邮箱地址 helpcenter@linktivity.co.jp
`,
        question: '购买后未收到确认邮件怎么办?'
      },
      {
        answer:
          '购买后或使用开始后无法使用二维码企划乘车券等疑问,请在邮件中注明"预约号码"和"姓名",联系购买方。',
        question: '无法使用二维码企划乘车券时怎么办?'
      }
    ]
  },
  ticket: {
    buy: '购买',
    qrcode: {
      desc: '使用二维码',
      title: '东京Metro 24小时券'
    },
    ticketLink: {
      qrcode:
        'https://tokyometrods.triplabo.com/zh/product/prod_agptukhko553njmyzlfzyjd2ie?utm_source=tokyometro-digital-ticket.triplabo.jp&utm_medium=referral&utm_campaign=v3_migration&utm_content=tokyo_metro_24h_ticket_all_languages'
    }
  }
};
